
import { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import useEventEmitter, {
  emitEvent,
} from "../../../hooks/useEventEmitter";
import {
  MILESTONE_REVISION_LOG,
  OPTIONAL_MILESTONE_REVISION_LOG,
} from "../types/CommonTypes";
import SideDrawer, {
  SideDrawerBody,
} from "../../../components/SideDrawer";
import RevisedMilestoneList from "./RevisedMilestoneList";
import getMilestoneDisplayName from "../helpers/getMilestoneDisplayName";

const REVISED_MILESTONE_TIME_DRAWER_EVENT =
  "REVISED_MILESTONE_TIME_DRAWER_EVENT";

export type RevisedMilestoneTimeDrawerProps = {
  milestoneName?: string;
  revision?: Array<
    MILESTONE_REVISION_LOG | OPTIONAL_MILESTONE_REVISION_LOG
  >;
};

export const toggleRevisedMilestoneTimeModal = (
  data?: RevisedMilestoneTimeDrawerProps
) => {
  emitEvent(REVISED_MILESTONE_TIME_DRAWER_EVENT, data);
};

const RevisedMilestoneTimeDrawer = () => {
  const { t } = useTranslation();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [milestoneDetail, setMilestoneDetail] =
    useState<RevisedMilestoneTimeDrawerProps>();

  const { milestoneName, revision } = milestoneDetail ?? {};

  useEventEmitter(
    REVISED_MILESTONE_TIME_DRAWER_EVENT,
    (data?: RevisedMilestoneTimeDrawerProps) => {
      setIsDrawerOpen((prev) => !prev);
      if (data) {
        setMilestoneDetail(data);
      }
    }
  );

  return (
    <SideDrawer
      visible={isDrawerOpen}
      onClose={() => setIsDrawerOpen(false)}
      title={t("Revised_Milestone_Time")}
    >
      <SideDrawerBody>
        <Box sx={styles.container}>
          {/* Milestone Heading */}
          <Box sx={styles.priorBanner}>
            <Typography sx={styles.title}>
              {t("Milestone_Revisions_for")}{" "}
              <Typography
                component="span"
                sx={styles.milestoneName}
              >
                {getMilestoneDisplayName(milestoneName)}
              </Typography>
            </Typography>
          </Box>

          {/* Revision History */}
          <Box sx={styles.revisionContainer}>
            <RevisedMilestoneList
              currentMilestoneRevisons={revision}
            />
          </Box>
        </Box>
      </SideDrawerBody>
    </SideDrawer>
  );
};

const styles = {
  container: {
    width: "100%",
  },
  priorBanner: {
    display: "flex",
    alignItems: "center",
    minHeight: "52px",
    borderLeft: "4px solid #673AB7",
    backgroundColor: "#E7E7E7",
    px: 2,
    py: 1,
    mb: 2,
    boxSizing: "border-box",
  },
  title: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#111111",
  },
  milestoneName: {
    fontWeight: 700,
  },
  revisionContainer: {
    backgroundColor: "#E7E7E7",
    borderRadius: "12px",
    padding: "16px",
  },
};

export default RevisedMilestoneTimeDrawer;
